import React from 'react';
import {Breadcrumb, Card, Form, Select, Typography} from 'antd';
import {HomeOutlined} from '@ant-design/icons';
import {Link} from 'react-router-dom';
import {useThemePalette} from '@/context/ThemeContext';
import {THEME_PRESETS, type ThemePreset} from '@/settings/themePreset';

const {Title, Text} = Typography;

const Settings: React.FC = () => {
	const {themePreset, setThemePreset} = useThemePalette();

	return (
		<>
			<Breadcrumb
				style={{marginBottom: 16}}
				items={[
					{
						title: (
							<Link to="/">
								<HomeOutlined />
							</Link>
						),
					},
					{title: 'Настройки'},
				]}
			/>
			<Title level={4}>Настройки</Title>
			<Card title="Тема" style={{marginBottom: 16}}>
				<Form layout="vertical">
					<Form.Item label="Оформление">
						<Select<ThemePreset>
							value={themePreset}
							onChange={setThemePreset}
							style={{width: 200}}
							options={THEME_PRESETS}
						/>
					</Form.Item>
					<Text type="secondary">
						Светлая — всё белое; Тёмная — всё тёмное; Синяя — синий акцент, белые
						карточки.
					</Text>
				</Form>
			</Card>
		</>
	);
};

export default Settings;
